<template>
  <footer class="footerV2">
    <div class="inner">
      <div class="lf">
        <el-dropdown class="friend-lk">
          <div class="el-dropdown-link">
            <div class="ti">友情链接</div>
            <span class="el-icon-caret-bottom"></span>
          </div>
          <el-dropdown-menu slot="dropdown" class="ouDrop">
            <el-dropdown-item v-for="item of options" :key="item.id" class="dp-item">
              <a :href="item.value" :title="item.label" target="_blank" class="link-item">{{item.label}}</a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="ft-column">
          <div class="item" v-for="item of columnData" :key="item.id">
            {{item.name}}
            <span>|</span>
          </div>
        </div>
        <div class="ft-info">
          <div>北京汇云博图科技有限公司版权所有©2024&nbsp;&nbsp;北京汇云博图科技有限公司运营</div>
          <div>联系电话：400-838-0150&nbsp;&nbsp;邮箱：market@broadtop.com </div>
          <div>
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP备13019296号-12</a>
            &nbsp;&nbsp;
            <img src="@/assets/balogo01.png" width="18" height="18">
            <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">京公网安备11010502054963号</a>
          </div>
        </div>
      </div>
      <div class="ri">
        <div class="qr-item" v-for="item of QrData" :key="item.id">
          <img :src="item.imgSrc">
          <div class="ti">{{item.name}}</div>
        </div>
      </div>
    </div>
    <el-backtop :bottom="100">
      <div
        style="{
        height: 100%;
        width: 100%;
        background-color: rgb(243 144 7);
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #fff;
      }"
      >
        UP
      </div>
    </el-backtop>
  </footer>
</template>

<script>
export default {
  name: "FootView",
  data () {
    return {
      options:[
        {
          value: 'https://www.broadtop.cn/',
          label: '汇云博图',
        },
      ],
      columnData:[
        {id:'c10001',name:'关于我们',path:''},
        {id:'c10002',name:'隐私政策',path:''},
        {id:'c10003',name:'证照信息',path:''},
        {id:'c10004',name:'版权投诉指引',path:''},
        {id:'c10005',name:'意见反馈',path:''},
        {id:'c10006',name:'个人信息收集清单',path:''},
      ],
      QrData:[
        {id:'qr10001',name:'汇云博图',imgSrc:require('@/assets/qr1.png')},
        {id:'qr10002',name:'汇云书舍',imgSrc:require('@/assets/qr2.png')},
        // {id:'qr10003',name:'APP下载',imgSrc:require('@/assets/qr3.png')},
      ],
    }
  },
}
</script>

<style lang="css" scoped>
.footerV2{
  background-repeat: no-repeat;
  background-position: left top;
  background-size: cover;
}
.inner,
.ri,
.ft-column{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap:nowrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
  .inner{
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    padding:50px 0;
  }
  .ft-column{
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    margin:20px 0;
    color:#fff;
  }
.ft-column .item{
  cursor: pointer;
}
.ft-column .item span{padding-left: 15px;padding-right: 15px}
.ft-column .item:last-child span{display: none}
  .ri{
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
  }
  .friend-lk{
    width: 200px;
    background-color: #fff;
    white-space: nowrap;
    cursor: pointer;
  }
.friend-lk .el-dropdown-link{
  width: 200px;
  padding: 5px 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.friend-lk .el-dropdown-link .el-icon-caret-bottom{
  color:#3C9B9E;
}
  .ft-info{
    color:#fff;
    font-size: 12px;
    line-height: 1.6;
  }
  .ft-info a{ color:#fff;}
  .qr-item{
    margin-left: 30px;
    text-align: center;
    color:#fff;
  }
.qr-item .ti{margin-top: 10px}
.qr-item img{
  width: 70px;
  height: 70px;
}
  .ouDrop{
    min-width: 200px;
  }
  .ouDrop .dp-item a{
display: block;
  }
</style>



// WEBPACK FOOTER //
// src/common/foot/FootView.vue